/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { UsageEntityType, UsageRestService } from '@gh/builder-shared-data';
import { InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';

export interface UsageDialogConfig {
  entityId: ID;
  entityType: UsageEntityType;
}

@Injectable()
export class UsageDialogBusinessService implements InitDialogViewService<UsageDialogConfig> {

  constructor(private restService: UsageRestService) {
  }

  initDialogView(route: DialogRouteSnapshot<UsageDialogConfig>): any {
    const { entityId, entityType } = route.input;
    return {
      usageData: this.restService.getUsageInfo(<ID>entityId, entityType),
    };
  }
}
